import { createSlice } from '@reduxjs/toolkit';
import { getOrderWithPresign, getOrders } from './thunk';

export const initialState = {
  orders: [],
  ordersTotal: 0,
  currentOrder: {},
  orderObject: [],
};

const OrderSlice = createSlice({
  name: 'Orders',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getOrders.fulfilled, (state: any, action: any) => {
      state.orders = action.payload?.data || [];
      state.ordersTotal = Number(action.payload?.total || 0);
    });
    builder.addCase(getOrderWithPresign.fulfilled, (state: any, action: any) => {
      state.orders = action.payload?.data || [];
      state.ordersTotal = Number(action.payload?.total || 0);
    });
  },
});

export default OrderSlice.reducer;
